(() => {
  const TARGET_SELECTOR = '.dj-review-strip, .dj-product-google-reviews, .dj-reviews-wrapper';
  const API_KEY = 'AIzaSyC905Wsmt6zdOtS2e1K14kWyZFIPPulqss';
  const PLACE_ID = 'ChIJEzKQaglrXz4RBx2dOXnBFhw';
  const MAPS_URL = 'https://www.google.com/maps/place/?q=place_id:' + PLACE_ID;
  const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const language = ['ar', 'ru'].includes(locale) ? locale : 'en';
  const copy = {
    en: {
      rating: (value, count) => `${value} Google rating (${count} reviews)`,
      stars: (value) => `${value} out of 5 stars`,
      googleReview: 'View review on Google',
      loading: 'Loading Google reviews…',
      unavailable: 'Google reviews are temporarily unavailable.',
    },
    ru: {
      rating: (value, count) => `Рейтинг Google ${value} (${count} отзывов)`,
      stars: (value) => `${value} из 5 звёзд`,
      googleReview: 'Посмотреть отзыв в Google',
      loading: 'Загрузка отзывов Google…',
      unavailable: 'Отзывы Google временно недоступны.',
    },
    ar: {
      rating: (value, count) => `تقييم Google ${value} (${count} مراجعة)`,
      stars: (value) => `${value} من 5 نجوم`,
      googleReview: 'عرض التقييم على Google',
      loading: 'جارٍ تحميل مراجعات Google…',
      unavailable: 'مراجعات Google غير متاحة مؤقتًا.',
    },
  }[language];

  let placeDataPromise;
  let mapsLoaderPromise;
  let mapsApi;
  let observerTimer;

  const loadMaps = () => {
    if (mapsApi?.importLibrary) return Promise.resolve(mapsApi);
    if (window.google?.maps?.importLibrary) {
      mapsApi = window.google.maps;
      return Promise.resolve(mapsApi);
    }
    if (mapsLoaderPromise) return mapsLoaderPromise;

    mapsLoaderPromise = new Promise((resolve, reject) => {
      const callbackName = `djGoogleMapsReady_${Date.now()}`;
      let settled = false;
      const finish = (callback, value, state) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        delete window[callbackName];
        document.documentElement.dataset.djGoogleMapsLoader = state;
        callback(value);
      };
      document.documentElement.dataset.djGoogleMapsLoader = 'loading';
      const timeout = window.setTimeout(() => {
        finish(reject, new Error('Google Maps loading timed out'), 'timeout');
      }, 15000);

      window[callbackName] = () => {
        mapsApi = window.google.maps;
        finish(resolve, mapsApi, 'ready');
      };

      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(API_KEY) +
        '&v=weekly&libraries=places&loading=async&language=' +
        encodeURIComponent(language) +
        '&region=AE&callback=' +
        encodeURIComponent(callbackName);
      script.onload = () => {
        if (window.google?.maps?.importLibrary) {
          mapsApi = window.google.maps;
          finish(resolve, mapsApi, 'ready');
        }
      };
      script.onerror = () => finish(reject, new Error('Google Maps failed to load'), 'script-error');
      document.head.append(script);
    });

    return mapsLoaderPromise;
  };

  const normalizeNewReview = (review) => ({
    authorName: review.authorAttribution?.displayName || '',
    authorUri: review.authorAttribution?.uri || review.googleMapsURI || MAPS_URL,
    authorPhoto: review.authorAttribution?.photoURI || '',
    rating: Number(review.rating || 0),
    relativeTime: review.relativePublishTimeDescription || '',
    text: review.text?.text || review.text || review.originalText?.text || review.originalText || '',
    uri: review.googleMapsURI || MAPS_URL,
  });

  const normalizeLegacyReview = (review) => ({
    authorName: review.author_name || '',
    authorUri: review.author_url || MAPS_URL,
    authorPhoto: review.profile_photo_url || '',
    rating: Number(review.rating || 0),
    relativeTime: review.relative_time_description || '',
    text: review.text || '',
    uri: MAPS_URL,
  });

  const fetchWithNewPlaces = async () => {
    document.documentElement.dataset.djGooglePlacesRequest = 'new-request';
    const { Place } = await mapsApi.importLibrary('places');
    const place = new Place({ id: PLACE_ID });
    await place.fetchFields({
      fields: [
        'displayName',
        'formattedAddress',
        'googleMapsURI',
        'rating',
        'reviews',
        'userRatingCount',
      ],
    });
    const data = {
      name: place.displayName || 'Double Jenya Flower Shop',
      address: place.formattedAddress || '',
      mapsUri: place.googleMapsURI || MAPS_URL,
      rating: Number(place.rating || 0),
      count: Number(place.userRatingCount || 0),
      reviews: (place.reviews || []).map(normalizeNewReview),
      attributions: Array.isArray(place.attributions) ? place.attributions : [],
    };
    document.documentElement.dataset.djGooglePlacesRequest = 'new-ready';
    return data;
  };

  const fetchWithLegacyPlaces = async () => {
    document.documentElement.dataset.djGooglePlacesRequest = 'legacy-request';
    await mapsApi.importLibrary('places');
    const service = new mapsApi.places.PlacesService(document.createElement('div'));
    const result = await new Promise((resolve, reject) => {
      service.getDetails(
        {
          placeId: PLACE_ID,
          fields: ['formatted_address', 'name', 'rating', 'reviews', 'url', 'user_ratings_total'],
        },
        (place, status) => {
          document.documentElement.dataset.djGooglePlacesStatus = String(status);
          if (status === mapsApi.places.PlacesServiceStatus.OK && place) resolve(place);
          else reject(new Error(`Google Places status: ${status}`));
        }
      );
    });
    const data = {
      name: result.name || 'Double Jenya Flower Shop',
      address: result.formatted_address || '',
      mapsUri: result.url || MAPS_URL,
      rating: Number(result.rating || 0),
      count: Number(result.user_ratings_total || 0),
      reviews: (result.reviews || []).map(normalizeLegacyReview),
      attributions: [],
    };
    document.documentElement.dataset.djGooglePlacesRequest = 'legacy-ready';
    return data;
  };

  const withTimeout = (promise, milliseconds, label) =>
    Promise.race([
      promise,
      new Promise((_, reject) =>
        window.setTimeout(() => reject(new Error(`${label} timed out`)), milliseconds)
      ),
    ]);

  const fetchPlaceData = async () => {
    await loadMaps();
    try {
      return await withTimeout(fetchWithNewPlaces(), 10000, 'Google Places request');
    } catch (newPlacesError) {
      document.documentElement.dataset.djGooglePlacesRequest = 'new-error';
      document.documentElement.dataset.djGooglePlacesNewError = String(
        newPlacesError?.message || newPlacesError
      ).slice(0, 180);
      return withTimeout(fetchWithLegacyPlaces(), 10000, 'Legacy Google Places request');
    }
  };

  const makeElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const makeReviewCard = (review) => {
    const card = makeElement('article', 'dj-google-live-review');
    const author = makeElement('div', 'dj-google-live-review__author');
    if (review.authorPhoto) {
      const image = document.createElement('img');
      image.className = 'dj-google-live-review__avatar';
      image.src = review.authorPhoto;
      image.alt = '';
      image.loading = 'lazy';
      image.referrerPolicy = 'no-referrer';
      author.append(image);
    }
    const authorText = makeElement('div', 'dj-google-live-review__author-text');
    const authorLink = makeElement('a', 'dj-google-live-review__author-name', review.authorName || 'Google user');
    authorLink.href = review.authorUri || MAPS_URL;
    authorLink.target = '_blank';
    authorLink.rel = 'noopener';
    authorText.append(authorLink);
    if (review.relativeTime) authorText.append(makeElement('span', 'dj-google-live-review__time', review.relativeTime));
    author.append(authorText);
    card.append(author);

    const rating = makeElement('div', 'dj-google-live-review__stars', '★★★★★');
    rating.setAttribute('aria-label', copy.stars(review.rating || 5));
    card.append(rating);
    if (review.text) card.append(makeElement('p', 'dj-google-live-review__text', review.text));

    const reviewLink = makeElement('a', 'dj-google-live-review__link', copy.googleReview);
    reviewLink.href = review.uri || MAPS_URL;
    reviewLink.target = '_blank';
    reviewLink.rel = 'noopener';
    card.append(reviewLink);
    return card;
  };

  const makeHomepageReviewCard = (review) => {
    const card = makeElement('li', 'dj-review-card');
    const header = makeElement('div', 'dj-review-card__header');
    const author = makeElement('div', 'dj-review-card__author-info');

    if (review.authorPhoto) {
      const image = document.createElement('img');
      image.className = 'dj-review-card__avatar';
      image.src = review.authorPhoto;
      image.alt = '';
      image.loading = 'lazy';
      image.referrerPolicy = 'no-referrer';
      author.append(image);
    }

    const authorText = makeElement('div');
    const authorLink = makeElement('a', 'dj-review-card__name', review.authorName || 'Google user');
    authorLink.href = review.authorUri || MAPS_URL;
    authorLink.target = '_blank';
    authorLink.rel = 'noopener';
    authorText.append(authorLink);
    if (review.relativeTime) authorText.append(makeElement('div', 'dj-review-card__date', review.relativeTime));
    author.append(authorText);
    header.append(author);
    header.append(makeElement('div', 'dj-review-card__rating', `${review.rating || 5}★`));
    card.append(header);

    const reviewLink = makeElement('a', 'dj-review-card__text', review.text || copy.googleReview);
    reviewLink.href = review.uri || MAPS_URL;
    reviewLink.target = '_blank';
    reviewLink.rel = 'noopener';
    card.append(reviewLink);
    return card;
  };

  const updateRating = (target, data) => {
    const value = data.rating.toFixed(1);
    const text = copy.rating(value, data.count.toLocaleString(language));
    const ratingNode =
      target.querySelector('.dj-product-google-reviews__rating') ||
      target.querySelector('.dj-reviews-rating-line > span:last-child') ||
      target.querySelector('.dj-review-strip__rating-line .dj-review-strip__rating') ||
      target.querySelector('.dj-review-strip__rating > span:last-child');
    if (ratingNode) ratingNode.textContent = text;
    const ratingContainer =
      target.querySelector('.dj-product-google-reviews__stars') ||
      target.querySelector('.dj-reviews-rating-line') ||
      target.querySelector('.dj-review-strip__rating-line') ||
      target.querySelector('.dj-review-strip__rating');
    if (ratingContainer) ratingContainer.setAttribute('aria-label', text);
  };

  const replaceStaticHomepageCards = (target, message) => {
    const track = target.querySelector('.dj-reviews-track');
    if (!track) return;
    const card = makeElement('li', 'dj-review-card');
    card.append(makeElement('div', 'dj-review-card__text', message));
    track.replaceChildren(card);
    const pagination = target.querySelector('.dj-reviews-pagination');
    if (pagination) pagination.replaceChildren();
  };

  const setStatusText = (target, message) => {
    const ratingNode =
      target.querySelector('.dj-product-google-reviews__rating') ||
      target.querySelector('.dj-reviews-rating-line > span:last-child') ||
      target.querySelector('.dj-review-strip__rating-line .dj-review-strip__rating') ||
      target.querySelector('.dj-review-strip__rating > span:last-child');
    if (ratingNode) ratingNode.textContent = message;
    replaceStaticHomepageCards(target, message);
  };

  const updateTarget = (target, data) => {
    if (target.dataset.djGoogleLiveBound === 'true') return;
    target.dataset.djGoogleLiveBound = 'true';
    target.dataset.djGoogleLiveState = 'ready';
    target.removeAttribute('aria-busy');

    updateRating(target, data);

    const homepageTrack = target.querySelector('.dj-reviews-track');
    if (homepageTrack) {
      homepageTrack.replaceChildren(...data.reviews.map(makeHomepageReviewCard));
      const pagination = target.querySelector('.dj-reviews-pagination');
      if (pagination) {
        pagination.dataset.count = String(data.reviews.length);
        pagination.replaceChildren(
          ...data.reviews.map((_, index) => {
            const dot = makeElement('span', `dj-reviews-dot${index === 0 ? ' is-active' : ''}`);
            dot.dataset.index = String(index);
            return dot;
          })
        );
      }
      target.dataset.djGoogleReviewCount = String(data.reviews.length);
      return;
    }

    const heading =
      target.querySelector('.dj-review-strip__heading-row h2') ||
      target.querySelector('.dj-product-google-reviews__heading');
    if (heading && data.name) heading.textContent = data.name;

    const address =
      target.querySelector('.dj-review-strip__address') ||
      target.querySelector('.dj-product-google-reviews__address');
    if (address && data.address) address.textContent = data.address;

    const host =
      target.querySelector('.dj-review-strip__summary') ||
      target.querySelector('.dj-product-google-reviews__panel--cta');
    if (!host) return;

    const staticSummary = host.querySelector('.rte, .dj-review-strip__summary-text');
    if (staticSummary) staticSummary.hidden = true;

    const oldLive = host.querySelector('[data-dj-google-live-reviews]');
    if (oldLive) oldLive.remove();

    const live = makeElement('div', 'dj-google-live-reviews');
    live.dataset.djGoogleLiveReviews = 'true';
    data.reviews.slice(0, 3).forEach((review) => live.append(makeReviewCard(review)));

    const button = host.querySelector('.dj-review-strip__button, .dj-product-google-reviews__button');
    if (button) {
      button.href = data.mapsUri || MAPS_URL;
      host.insertBefore(live, button);
    } else {
      host.append(live);
    }

    if (data.attributions.length) {
      const attribution = makeElement('div', 'dj-google-live-attributions');
      data.attributions.forEach((item) => attribution.append(makeElement('span', '', String(item))));
      host.append(attribution);
    }
  };

  const markLoading = () => {
    document.querySelectorAll(TARGET_SELECTOR).forEach((target) => {
      if (target.dataset.djGoogleLiveBound === 'true') return;
      target.dataset.djGoogleLiveState = 'loading';
      target.setAttribute('aria-busy', 'true');
      setStatusText(target, copy.loading);
    });
  };

  const renderAll = async () => {
    const targets = Array.from(document.querySelectorAll(TARGET_SELECTOR)).filter(
      (target) => !target.dataset.djGoogleLiveBound
    );
    if (!targets.length) return;
    markLoading();
    try {
      placeDataPromise ||= fetchPlaceData();
      const data = await placeDataPromise;
      if (!data.rating || !data.count || !data.reviews.length) throw new Error('Incomplete Google review data');
      targets.forEach((target) => updateTarget(target, data));
    } catch (error) {
      document.documentElement.dataset.djGooglePlacesError = String(error?.message || error).slice(0, 180);
      targets.forEach((target) => {
        target.dataset.djGoogleLiveBound = 'error';
        target.dataset.djGoogleLiveState = 'error';
        target.removeAttribute('aria-busy');
        setStatusText(target, copy.unavailable);
      });
      console.error('[DJ Google reviews]', error);
    }
  };

  const start = () => {
    renderAll();
    new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(renderAll, 120);
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('pageshow', renderAll);
})();
